<script lang="ts">
	import { onMount } from "svelte";
	import Button from "./Button.svelte";
	import ProductInquiryModal from "./ProductInquiryModal.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { formatPhoneNumber } from "../../../core/utils/formatPhoneNumber.js";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import translations from "./HotlineGetInTouch.translations.json";

	onMount(() => {
		const scrollToCenter = (): void => {
			if (window.location.hash === "#hotline") {
				document.getElementById("hotline")?.scrollIntoView({ behavior: "smooth", block: "center" });
			}
		};

		scrollToCenter();
		window.addEventListener("hashchange", scrollToCenter);
		return (): void => {
			window.removeEventListener("hashchange", scrollToCenter);
		};
	});

	const translate = getTranslate(translations);

	export let variant: "default" | "bordered" = "default";

	const CONTACT_NUMBER = "+420554818554";

	let showInquiryModal = false;
</script>

{#if variant === "bordered"}
	<section id="hotline" class="!my-0">
		<div class="bg-ltprimary-400 py-12 xl:py-24">
			<div class="border-lttertiary border-y">
				<div class="mx-auto flex max-w-[120rem] flex-col px-8 md:flex-row lg:px-20 xl:flex-row xl:px-32">
					<div class="border-lttertiary flex-1 border-x border-b p-8 text-white md:border-b-0">
						<h2 class="text-lttertiary mb-4 text-center uppercase tracking-[0.02em] md:text-left">
							{translate("hotline")}
						</h2>
						<p class="!text-2md mb-10 leading-normal">{translate("hotlineDesc")}</p>
						<p class="font-lexend !text-md/normal lg:!text-2lg/normal font-normal tracking-normal">
							<a href="tel:{CONTACT_NUMBER}">
								{nbspify(formatPhoneNumber(CONTACT_NUMBER))}
							</a>
						</p>
					</div>
					<div class="border-lttertiary flex-1 border-l border-r p-8 text-white md:border-l-0">
						<h2 class="text-lttertiary mb-4 text-center uppercase tracking-[0.02em] md:text-left">
							{translate("getInTouch")}
						</h2>
						<p class="!text-2md mb-10 leading-normal">{translate("getInTouchDesc")}</p>
						<Button
							variant="primary"
							icon={arrowRight}
							on:click={() => {
								showInquiryModal = true;
							}}
						>
							{translate("getInTouchAction")}
						</Button>
					</div>
				</div>
			</div>
		</div>
	</section>
{:else}
	<section id="hotline" class="!my-0">
		<div class="bg-ltprimary-400 py-24">
			<div class="border-lttertiary border-y">
				<div class="mx-auto flex max-w-[120rem] flex-col px-4 md:flex-row md:px-9 lg:px-16 xl:px-32">
					<div class="border-1 border-lttertiary flex-1 border-x p-8 text-white">
						<h2 class="text-lttertiary mb-4 uppercase tracking-[0.02em]">{translate("hotline")}</h2>
						<p class="!text-2md mb-10 leading-normal">{translate("hotlineDesc")}</p>
						<p class="font-lexend !text-2lg/normal font-normal tracking-normal">
							<a href="tel:{CONTACT_NUMBER}">
								{nbspify(formatPhoneNumber(CONTACT_NUMBER))}
							</a>
						</p>
					</div>
					<div class="border-1 border-lttertiary flex-1 border-l border-r p-8 text-white md:border-l-0">
						<h2 class="text-lttertiary mb-4 uppercase tracking-[0.02em]">{translate("getInTouch")}</h2>
						<p class="!text-2md mb-10 leading-normal">{translate("getInTouchDesc")}</p>
						<Button
							variant="primary"
							icon={arrowRight}
							on:click={() => {
								showInquiryModal = true;
							}}
						>
							{translate("getInTouchAction")}
						</Button>
					</div>
				</div>
			</div>
		</div>
	</section>
{/if}

<ProductInquiryModal bind:show={showInquiryModal} />
